module.exports = __webpack_public_path__ + "img/20201213_133641.a3e8ed4a.jpg";